/**
 * ULD历史记录相关常量定义
 */

// ULD事件类型枚举及其显示信息（基于V3模型）
export const ULD_EVENT_TYPE = {
    // V3模型标准事件类型
    LOC_CHANGE: 'LOC_CHANGE',
    STATUS_CHANGE: 'STATUS_CHANGE',
    TAG_ADD: 'TAG_ADD',
    TAG_REMOVE: 'TAG_REMOVE',
    TAG_CHANGE: 'TAG_CHANGE',
    HOLDER_UPDATE: 'HOLDER_UPDATE',
    LOADED: 'LOADED',
    UNLOADED: 'UNLOADED',
    CORRECTION: 'CORRECTION',
    STOCK_IN: 'STOCK_IN',
    
    // 扩展事件类型
    CORE_STATUS_CHANGE: 'CORE_STATUS_CHANGE',
    REMARKS_UPDATE: 'REMARKS_UPDATE',
    DELIVERY: 'DELIVERY',
    DELIVERY_REVOKE: 'DELIVERY_REVOKE',
    
    // 向后兼容的历史事件类型
    CREATE: 'CREATE',
    UPDATE: 'UPDATE',
    DELETE: 'DELETE',
    LOCATION_UPDATE: 'LOCATION_UPDATE',
    STATUS_UPDATE: 'STATUS_UPDATE',
    TAG_MANAGE: 'TAG_MANAGE',
    BATCH_CREATE: 'BATCH_CREATE',
    BATCH_UPDATE: 'BATCH_UPDATE',
};

export const ULD_EVENT_TYPE_LABELS = {
    // V3模型标准事件类型中文标签
    [ULD_EVENT_TYPE.LOC_CHANGE]: '位置变更',
    [ULD_EVENT_TYPE.STATUS_CHANGE]: '状态变更',
    [ULD_EVENT_TYPE.TAG_ADD]: '添加标签',
    [ULD_EVENT_TYPE.TAG_REMOVE]: '移除标签',
    [ULD_EVENT_TYPE.TAG_CHANGE]: '标签管理',
    [ULD_EVENT_TYPE.HOLDER_UPDATE]: '持有者更新',
    [ULD_EVENT_TYPE.LOADED]: '装载',
    [ULD_EVENT_TYPE.UNLOADED]: '卸载',
    [ULD_EVENT_TYPE.CORRECTION]: '数据校正',
    [ULD_EVENT_TYPE.STOCK_IN]: '入库',
    
    // 扩展事件类型中文标签
    [ULD_EVENT_TYPE.CORE_STATUS_CHANGE]: '核心状态变更',
    [ULD_EVENT_TYPE.REMARKS_UPDATE]: '备注更新',
    [ULD_EVENT_TYPE.DELIVERY]: '外放给收货人',
    [ULD_EVENT_TYPE.DELIVERY_REVOKE]: '撤销外放',
    
    // 向后兼容的历史事件类型中文标签
    [ULD_EVENT_TYPE.CREATE]: '创建ULD',
    [ULD_EVENT_TYPE.UPDATE]: '更新基础信息',
    [ULD_EVENT_TYPE.DELETE]: '删除ULD',
    [ULD_EVENT_TYPE.LOCATION_UPDATE]: '位置变更',
    [ULD_EVENT_TYPE.STATUS_UPDATE]: '状态变更',
    [ULD_EVENT_TYPE.TAG_MANAGE]: '标签管理',
    [ULD_EVENT_TYPE.BATCH_CREATE]: '批量创建',
    [ULD_EVENT_TYPE.BATCH_UPDATE]: '批量更新',
};

export const ULD_EVENT_TYPE_COLORS = {
    // V3模型标准事件类型颜色
    [ULD_EVENT_TYPE.LOC_CHANGE]: '#fa8c16',       // 橙色 - 位置变更
    [ULD_EVENT_TYPE.STATUS_CHANGE]: '#722ed1',    // 紫色 - 状态变更
    [ULD_EVENT_TYPE.TAG_ADD]: '#52c41a',          // 绿色 - 添加标签
    [ULD_EVENT_TYPE.TAG_REMOVE]: '#ff7875',       // 浅红色 - 移除标签
    [ULD_EVENT_TYPE.TAG_CHANGE]: '#eb2f96',       // 粉色 - 标签管理
    [ULD_EVENT_TYPE.HOLDER_UPDATE]: '#13c2c2',    // 青色 - 持有者更新
    [ULD_EVENT_TYPE.LOADED]: '#1890ff',           // 蓝色 - 装载
    [ULD_EVENT_TYPE.UNLOADED]: '#2f54eb',         // 深蓝 - 卸载
    [ULD_EVENT_TYPE.CORRECTION]: '#faad14',       // 黄色 - 数据校正
    [ULD_EVENT_TYPE.STOCK_IN]: '#52c41a',         // 绿色 - 入库
    
    // 扩展事件类型颜色
    [ULD_EVENT_TYPE.CORE_STATUS_CHANGE]: '#722ed1', // 紫色 - 核心状态变更
    [ULD_EVENT_TYPE.REMARKS_UPDATE]: '#87d068',     // 浅绿色 - 备注更新
    [ULD_EVENT_TYPE.DELIVERY]: '#fa8c16',           // 橙色 - 外放给收货人
    [ULD_EVENT_TYPE.DELIVERY_REVOKE]: '#faad14',    // 金色 - 撤销外放
    
    // 向后兼容的历史事件类型颜色
    [ULD_EVENT_TYPE.CREATE]: '#52c41a',           // 绿色 - 创建
    [ULD_EVENT_TYPE.UPDATE]: '#1890ff',           // 蓝色 - 更新
    [ULD_EVENT_TYPE.DELETE]: '#ff4d4f',           // 红色 - 删除
    [ULD_EVENT_TYPE.LOCATION_UPDATE]: '#fa8c16',  // 橙色 - 位置变更
    [ULD_EVENT_TYPE.STATUS_UPDATE]: '#722ed1',    // 紫色 - 状态变更
    [ULD_EVENT_TYPE.TAG_MANAGE]: '#eb2f96',       // 粉色 - 标签管理
    [ULD_EVENT_TYPE.BATCH_CREATE]: '#13c2c2',     // 青色 - 批量创建
    [ULD_EVENT_TYPE.BATCH_UPDATE]: '#2f54eb',     // 深蓝 - 批量更新
};

// ULD状态枚举
export const ULD_STATUS = {
    AVL: 'AVL',    // 可用
    SRV: 'SRV',    // 维修中
    UNS: 'UNS',    // 不适用
    DAM: 'DAM',    // 损坏
    HLD: 'HLD',    // 留置
    SCR: 'SCR',    // 报废
    LOST: 'LOST',  // 丢失
};

export const ULD_STATUS_LABELS = {
    [ULD_STATUS.AVL]: '可用',
    [ULD_STATUS.SRV]: '维修中',
    [ULD_STATUS.UNS]: '不适用',
    [ULD_STATUS.DAM]: '损坏',
    [ULD_STATUS.HLD]: '留置',
    [ULD_STATUS.SCR]: '报废',
    [ULD_STATUS.LOST]: '丢失',
};

export const ULD_STATUS_COLORS = {
    [ULD_STATUS.AVL]: '#52c41a',     // 绿色
    [ULD_STATUS.SRV]: '#1890ff',     // 蓝色
    [ULD_STATUS.UNS]: '#faad14',     // 黄色
    [ULD_STATUS.DAM]: '#ff7875',     // 浅红色
    [ULD_STATUS.HLD]: '#fa8c16',     // 橙色
    [ULD_STATUS.SCR]: '#ff4d4f',     // 红色
    [ULD_STATUS.LOST]: '#722ed1',    // 紫色
};

// ULD位置类型枚举
export const ULD_LOCATION_TYPE = {
    AIRPORT: 'AIRPORT',
    FLIGHT: 'FLIGHT',
    OTHER_LOCATION: 'OTHER_LOCATION',
};

export const ULD_LOCATION_TYPE_LABELS = {
    [ULD_LOCATION_TYPE.AIRPORT]: '机场',
    [ULD_LOCATION_TYPE.FLIGHT]: '航班',
    [ULD_LOCATION_TYPE.OTHER_LOCATION]: '其他位置',
};

// 历史记录筛选器选项
export const HISTORY_FILTER_OPTIONS = {
    // 时间范围选项
    TIME_RANGES: [
        { label: '今天', value: 'today' },
        { label: '最近7天', value: 'week' },
        { label: '最近30天', value: 'month' },
        { label: '最近90天', value: 'quarter' },
        { label: '自定义', value: 'custom' },
    ],
    
    // 排序选项
    SORT_OPTIONS: [
        { label: '时间倒序', value: 'event_timestamp', order: 'desc' },
        { label: '时间顺序', value: 'event_timestamp', order: 'asc' },
        { label: 'ULD识别码', value: 'uld_identifier', order: 'asc' },
        { label: '事件类型', value: 'event_type', order: 'asc' },
    ],
};

// 时间范围计算函数
export const getTimeRange = (rangeType) => {
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    
    switch (rangeType) {
        case 'today':
            return {
                start_date: today.toISOString(),
                end_date: new Date(today.getTime() + 24 * 60 * 60 * 1000 - 1).toISOString(),
            };
        case 'week':
            return {
                start_date: new Date(today.getTime() - 7 * 24 * 60 * 60 * 1000).toISOString(),
                end_date: now.toISOString(),
            };
        case 'month':
            return {
                start_date: new Date(today.getTime() - 30 * 24 * 60 * 60 * 1000).toISOString(),
                end_date: now.toISOString(),
            };
        case 'quarter':
            return {
                start_date: new Date(today.getTime() - 90 * 24 * 60 * 60 * 1000).toISOString(),
                end_date: now.toISOString(),
            };
        default:
            return {};
    }
};

// 默认分页设置
export const DEFAULT_PAGE_SIZE = 20;
export const DEFAULT_PAGE = 1;

// 历史记录表格列配置
export const HISTORY_TABLE_COLUMNS = [
    {
        title: 'ULD识别码',
        dataIndex: 'uld_identifier',
        key: 'uld_identifier',
        width: 120,
        fixed: 'left',
    },
    {
        title: '事件类型',
        dataIndex: 'event_type',
        key: 'event_type',
        width: 100,
    },
    {
        title: '事件时间',
        dataIndex: 'event_timestamp',
        key: 'event_timestamp',
        width: 160,
    },
    {
        title: '航班号',
        dataIndex: 'flight_number',
        key: 'flight_number',
        width: 100,
    },
    {
        title: '运输标识',
        dataIndex: 'transport_identifier',
        key: 'transport_identifier',
        width: 120,
    },
    {
        title: '机场',
        dataIndex: 'airport_iata',
        key: 'airport_iata',
        width: 80,
    },
    {
        title: '机场名称',
        dataIndex: 'airport_name',
        key: 'airport_name',
        width: 150,
    },
    {
        title: '操作用户',
        dataIndex: 'user_id',
        key: 'user_id',
        width: 100,
    },
    {
        title: '原因',
        dataIndex: 'reason',
        key: 'reason',
        width: 200,
    },
    {
        title: '批次标识',
        dataIndex: 'batch_identifier',
        key: 'batch_identifier',
        width: 120,
    },
]; 